"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getSelectedTheme = _interopRequireDefault(require("./getSelectedTheme"));

var _getThemeFromRegistry = _interopRequireDefault(require("./getThemeFromRegistry"));

var _getDefaultThemeName = _interopRequireDefault(require("./getDefaultThemeName"));

/**
 * Initialize the selected theme if the theme is not already set in storage
 * If the selected theme is falsy and the themeName parameter is falsy then the theme is initialized to the
 * theme name
 * @param {string}  themeName The string name to use if it is truthy
 * @param {object}  themeRegistry The list of themes available to the app
 * @param {function} setCurrentTheme The callback to set the current theme
 */
var initializeSelectedTheme = function initializeSelectedTheme(themeName, themeRegistry, setCurrentTheme) {
  // If the there is already a theme set in storage then we'll use that theme
  var selectedTheme = (0, _getSelectedTheme.default)();
  var selectedRegistryTheme = (0, _getThemeFromRegistry.default)(selectedTheme, themeRegistry);

  if (!selectedRegistryTheme) {
    if (themeName) {
      setCurrentTheme(themeName);
    } else {
      (0, _getDefaultThemeName.default)().then(function (defaultThemeName) {
        if (defaultThemeName) {
          setCurrentTheme(defaultThemeName);
        } else {
          setCurrentTheme("Cx");
        }
      });
    }
  } else {
    setCurrentTheme(selectedRegistryTheme.themeName);
  }
};

var _default = initializeSelectedTheme;
exports.default = _default;